$(function () {
  $('.js-slider').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    autoplay: true,
    dots: true,
    customPaging: function (slick, index) {
      // スライダーのインデックス番号に対応した画像のsrcを取得
      var targetImage = slick.$slides.eq(index).find('img').attr('src');
      // slick-dots > li　の中に上記で取得した画像を設定
      return '<span style="background-image:url(' + targetImage + ')"/></span>';
    }
  });
});
